module.exports = __webpack_public_path__ + "img/connext.288e210f.svg";